import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faAnglesRight, faCheckCircle, faCheckDouble, faTimes } from '@fortawesome/free-solid-svg-icons';


const Accordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionData = [
        {
            title: 'Single User License',
            content: <><div>
                <ul>
                    <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> Only single designated user can access the report </li>
                    <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 3 Months Post Sale Support</li>
                    <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 48 hours query resolving time</li>
                    <li><i className="fa-solid fa-times text-sm pr-2 text-[#e70e02]"></i> Dynamic Excel Model</li>
                </ul>
            </div></>,
        },
        {
            title: '2-3 Users License',
            content: <><div>
                <ul>
                    <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> Only 2-3 designated user can access the report  </li>
                    <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 3 Months Post Sale Support</li>
                    <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 48 hours query resolving time</li>
                    <li><i className="fa-solid fa-times text-sm pr-2 text-[#e70e02]"></i> Dynamic Excel Model</li>
                </ul>
            </div></>,
        },
        {
            title: 'Site License',
            content: <ul>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> One Site access  </li>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 6 Months Post Sale Support</li>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 36 hours query resolving time</li>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> Dynamic Excel Model</li>
            </ul>,
        },
        {
            title: 'Global License',
            content: <ul>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i>  Global access   </li>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 9 Months Post Sale Support</li>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> 24 hours query resolving time</li>
                <li><i className="fa-solid fa-check text-sm pr-2 text-[#01a23c]"></i> Dynamic Excel Model</li>
            </ul>,
        },
    ];

    return (
        <div className="w-full">
            {accordionData?.map((item, index) => (
                <div key={index} className="mb-2 border border-[#d3e0ff] rounded-md">
                    <button
                        className={activeIndex === index ? 'w-full bg-[#d3e0ff] hover:text-[#1b5df3] text-[#1b5df3] text-left py-2 px-4 rounded-md flex justify-between items-center' : 'w-full bg-[#d3e0ff] hover:text-[#1b5df3] text-left py-2 px-4 rounded-md flex justify-between items-center'}
                        onClick={() => toggleAccordion(index)}>
                        <span>{item?.title}</span>
                        <FontAwesomeIcon
                            icon={activeIndex === index ? faMinus : faPlus}
                            className="ml-2"
                        />
                    </button>
                    {activeIndex === index && (
                        <div className="bg-white p-4 rounded-md">
                            {item?.content}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Accordion;
